import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { AngularFireAuth } from 'angularfire2/auth';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {

  constructor(public afAuth: AngularFireAuth) {
    console.log('Hello AuthProvider Provider'); 
  }

  loginUser(newEmail: string, newPassword: string){
    return this.afAuth.auth.signInWithEmailAndPassword(newEmail, newPassword).then(value => {
      console.log('Nice, it worked!');
    })
    .catch(err => {
      console.log('Something went wrong:',err.message);
    });
  }

  logoutUser(){
    return this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts